const {
    GET_ALL_DEVIS_REQUEST,
    GET_ALL_DEVIS_SUCCESS,
    GET_ALL_DEVIS_FAIL,
    ADD_DEVIS_REQUEST,
    ADD_DEVIS_SUCCESS,
    ADD_DEVIS_FAIL,
    GET_DEVIS_REQUEST,
    GET_DEVIS_SUCCESS,
    GET_DEVIS_FAIL,
    UPDATE_DEVIS_REQUEST,
    UPDATE_DEVIS_SUCCESS,
    UPDATE_DEVIS_FAIL,
    DELETE_DEVIS_REQUEST,
    DELETE_DEVIS_SUCCESS,
    DELETE_DEVIS_FAIL,
    ADD_DVARTICLE_REQUEST,
    ADD_DVARTICLE_SUCCESS,
    ADD_DVARTICLE_FAIL,
    UPDATE_DVARTICLE_REQUEST,
    UPDATE_DVARTICLE_SUCCESS,
    UPDATE_DVARTICLE_FAIL,
    DELETE_DVARTICLE_REQUEST,
    DELETE_DVARTICLE_SUCCESS,
    DELETE_DVARTICLE_FAIL
} = require("../../actionTypes/Vente/Devis");

  
  function getAllDevis(state = { data: {} }, action) {
    switch (action.type) {
      case GET_ALL_DEVIS_REQUEST:
        return { loading: true, data: {} };
      case GET_ALL_DEVIS_SUCCESS:
        return { loading: false, data: action.payload };
      case GET_ALL_DEVIS_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function getDevis(state = { data: {} }, action) {
    switch (action.type) {
      case GET_DEVIS_REQUEST:
        return { loading: true, data: {} };
      case GET_DEVIS_SUCCESS:
        return { loading: false, data: action.payload };
      case GET_DEVIS_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function addDevis(state = { data: {} }, action) {
    switch (action.type) {
      case ADD_DEVIS_REQUEST:
        return { loading: true, data: {} };
      case ADD_DEVIS_SUCCESS:
        return { loading: false, data: action.payload };
      case ADD_DEVIS_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function updateDevis(state = { data: {} }, action) {
    switch (action.type) {
      case UPDATE_DEVIS_REQUEST:
        return { loading: true, data: {} };
      case UPDATE_DEVIS_SUCCESS:
        return { loading: false, data: action.payload };
      case UPDATE_DEVIS_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function deleteDevis(state = { data: {} }, action) {
    switch (action.type) {
      case DELETE_DEVIS_REQUEST:
        return { loading: true, data: {} };
      case DELETE_DEVIS_SUCCESS:
        return { loading: false, data: action.payload };
      case DELETE_DEVIS_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function addDVArticle(state = { data: {} }, action) {
    switch (action.type) {
      case ADD_DVARTICLE_REQUEST:
        return { loading: true, data: {} };
      case ADD_DVARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case ADD_DVARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function updateDVArticle(state = { data: {} }, action) {
    switch (action.type) {
      case UPDATE_DVARTICLE_REQUEST:
        return { loading: true, data: {} };
      case UPDATE_DVARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case UPDATE_DVARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  function deleteDVArticle(state = { data: {} }, action) {
    switch (action.type) {
      case DELETE_DVARTICLE_REQUEST:
        return { loading: true, data: {} };
      case DELETE_DVARTICLE_SUCCESS:
        return { loading: false, data: action.payload };
      case DELETE_DVARTICLE_FAIL:
        return { loading: false, error: action.data };
      default:
        return state;
    }
  }
  
  export {
    addDevis,
    getDevis,
    updateDevis,
    deleteDevis,
    getAllDevis,
    addDVArticle,
    updateDVArticle,
    deleteDVArticle
  };
  